/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "DocumentSearchUser",
            "endpoint": "https://5pna04qxa9.execute-api.ca-central-1.amazonaws.com/lawai",
            "region": "ca-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ca-central-1:412bbb17-6275-4771-94ae-de77f4168470",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_whfnZC0a6",
    "aws_user_pools_web_client_id": "7iprrvg0dnl26co6s6cnnks1gl",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "npm-document-understanding40925-lawai",
    "aws_user_files_s3_bucket_region": "ca-central-1"
};


export default awsmobile;
